import { Box, Button, Switch } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BasicPagination from "@app/components/Pagination";

import { StyledImage, StyledTableCell } from "./styled";
import { useTeamListLogic } from "./useTeamListLogic";

const Teams = () => {
  const {
    teamList,
    pagesCount,
    handleDeleteTeam,
    handlePagination
  } = useTeamListLogic()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Box display="flex" gap={1}>
        <Link to={PRIVATE_PAGES.UPDATE_TEAMS_ORDERING}>
          <Button variant="contained" color="primary">
            Change Ordering
          </Button>
        </Link>
        <Link to={PRIVATE_PAGES.CREATE_TEAMS}>
          <Button variant="contained" color="primary">
            Create Member
          </Button>
        </Link>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">IMAGE</TableCell>
              <TableCell align="center">Name En</TableCell>
              <TableCell align="center">Name Ru</TableCell>
              <TableCell align="center">Name AM</TableCell>
              <TableCell align="center">Position En</TableCell>
              <TableCell align="center">Position Ru</TableCell>
              <TableCell align="center">Position AM</TableCell>
              <TableCell align="center">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamList.map((team) => {
              const image = team.images.find(({ isMain }) => isMain)?.url || team.images[0]?.url

              return (
                <TableRow key={team.id}>
                  <TableCell align="center">
                    <StyledImage
                      alt="product"
                      src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                    />
                  </TableCell>
                  <TableCell align="center">{team.nameAm}</TableCell>
                  <TableCell align="center">{team.nameEn}</TableCell>
                  <TableCell align="center">{team.nameRu}</TableCell>
                  <TableCell align="center">{team.positionAm}</TableCell>
                  <TableCell align="center">{team.positionEn}</TableCell>
                  <TableCell align="center">{team.positionRu}</TableCell>
                  <StyledTableCell align="center">
                    <Link to={`/team/${team.id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <Button variant="contained" onClick={() => handleDeleteTeam(team.id)}>
                      Delete
                    </Button>
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BasicPagination count={pagesCount} callback={handlePagination} />
    </Box>
  )
};

export default Teams;
